





















































































































import GroupService from '@/services/GroupService'
import InfomationService from '@/services/InfomationService'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import { containsJapanese, decodeHtml, getInlineEditorImageSrcFromClick, handleTranslation } from '@/helpers/Common'
import Const, { TRANSLATION_TYPE } from '@/constants'

@Component({ components: { ModalFullImageViewer } })
export default class NewsComponent extends Vue {
  @Prop() loadingLine!: number
  isLoading: boolean = true
  news: News[] = []
  eNewsType: any = NewsType
  eNewsTargetType: any = NewsTargetType
  private numberOfNewsShowFirst: number = 3
  private perPage: number = this.numberOfNewsShowFirst
  isLoadingMore: boolean = false
  currentCursor: string = ''
  errorMess: string = ''
  canOpenFullImageModal: boolean = false
  fullOverviewSrc: string = ''

  created() {
    this.$route.params.groupId ? this.getGroupNews() : this.getHomeNews()
  }

  viewMoreNews() {
    this.perPage = this.$store.state.setting.setting.setting_display.number_item_lists
    this.$route.params.groupId ? this.getGroupNews() : this.getAllGroupsNews()
  }

  onCmsNewsInlineEditorImageClick(e: MouseEvent) {
    const root = e.currentTarget as HTMLElement
    const src = getInlineEditorImageSrcFromClick(e, root)
    if (!src) return
    e.preventDefault()
    e.stopPropagation()
    this.fullOverviewSrc = src
    this.canOpenFullImageModal = true
  }

  private async getSystemNews() {
    this.isLoading = true
    const response = await InfomationService.getInformation()
    if (response.status === 200 && response.data.length) {
      const mappingData = response.data.map((item: any) => ({
        ...item,
        isTranslated: false
      }))
      this.news = mappingData
    }
    this.isLoading = false
  }

  private getAllGroupsNews() {
    this.isLoadingMore = true
    InfomationService.getGroupInformations({
      per_page: this.perPage,
      cursor: this.currentCursor
    })
      .then(res => {
        if (res.status === 200) {
          const { data, next_cursor } = res.data || {}
          if (data.length) {
            const uniqueNews = Array.from(
              new Map(
                [...this.news, ...data].map(item => [
                  JSON.stringify(item),
                  item
                ])
              ).values()
            )
            const mappingData = uniqueNews.map((item: any) => ({
              ...item,
              isTranslated: false
            }))
            this.news = mappingData
            this.currentCursor = next_cursor
            this.markAsReadAll()
          } else if (this.news.length) {
              this.markAsReadAll()
            } else {
              this.$emit('noNews', true)
            }
        }
      })
      .finally(() => {
        this.isLoadingMore = false
        this.isLoading = false
      })
  }

  private async getHomeNews() {
    await this.getSystemNews()
    this.getAllGroupsNews()
  }

  private resetState() {
    this.news = []
    this.perPage = this.numberOfNewsShowFirst
    this.currentCursor = ''
  }

  /**
   * Call API get group news
   */
  @Watch('$route.params.groupId')
  private getGroupNews(newValue?: string, oldValue?: string) {
    // reset data
    if (newValue !== oldValue) {
      this.resetState()
    }
    this.isLoadingMore = true
    GroupService.getGroupNews(this.$route.params.groupId, {
      per_page: this.perPage,
      cursor: this.currentCursor
    })
      .then(res => {
        if (res.status === 200) {
          const { data, next_cursor } = res.data || {}
          if (data.length) {
            const uniqueNews = Array.from(
              new Map(
                [...this.news, ...data].map(item => [
                  JSON.stringify(item),
                  item
                ])
              ).values()
            )
            this.news = uniqueNews
            this.currentCursor = next_cursor
            this.markAsReadAll()
          } else {
            this.$emit('noNews', true)
          }
        }
      })
      .finally(() => {
        this.isLoadingMore = false
        this.isLoading = false
      })
  }

  /**
   * go to detail from news
   */
  goToDetailRoute(index: number) {
    let informationClick = this.news[index]

    let target_type = informationClick.target_type
    let target_id = informationClick.target_id

    switch (target_type) {
      case NewsTargetType.NO_LINK:
        if (['msg_10', 'msg_11'].includes(informationClick.title)) {
          return {
            name: 'group-setting',
            params: { groupId: String(target_id) }
          }
        }
        return {}
      case NewsTargetType.GROUP_TOP:
        return { name: 'group', params: { groupId: String(target_id) } }
      case NewsTargetType.GROUP_APPROVE:
        return {
          name: 'group-members-join-request',
          params: { groupId: `${target_id}` }
        }
      case NewsTargetType.GROUP_SETTING:
        //open c3-401 setting group CMS
        // window.open(Const.cms_url + 'admin/group-setting', 'blank')
        // break
        return Const.cms_url + 'admin/group-setting'
      case NewsTargetType.GROUP_SHARED_FOLDER:
        return {
          name: 'group-shared-folder',
          params: { groupId: `${target_id}` }
        }
      case NewsTargetType.MY_CALENDAR:
        return { name: 'calendar' }
      case NewsTargetType.GROUP_TOPIC:
      case NewsTargetType.CHAT:
        return {
          name: 'mention',
        }
      case NewsTargetType.ACCEPTANCE:
        return { name: 'acceptance' }
      default:
        return {}
    }
  }

  /**
   * go to detail from news
   */
  goToDetail(index: number) {
    let informationClick = this.news[index]

    if (informationClick.display_type === DisplayType.ONE_TIME) {
      this.markAsRead()
    } else {
      this.markAsRead(index)
    }
  }

  /**
   * Mark news read
   */
  markAsRead(index?: number) {
    console.log('mark read')
    let informationSelect: (number | undefined)[] =
      index === undefined
        ? this.news
            .filter(
              item =>
                item.type === NewsType.SYSTEM &&
                item.display_type === DisplayType.ONE_TIME
            )
            .map(item => item.id)
        : [this.news[index].id]

    let selectedInformation: number[] = informationSelect.filter(Boolean) as number[]
    if (!selectedInformation.length) return

    InfomationService.markReadInformation(selectedInformation)
      .then(res => {
        if (res.status === 200 && index !== undefined) {
          this.news[index].is_readed = true
        }
      })
      .catch(err => {
        // err.response.status === 400 && err.response.data.message === 'ITEM_EXISTS_THAT_IS_NOT_INFORMATION'
        console.log(err)
      })
  }

  /**
   * Mark all news read
   */
  private markAsReadAll() {
    console.log('markAsReadAll')
    let informationSelect: (number | undefined)[] = this.news.map(item => item.id)
    let selectedInformation: number[] = informationSelect.filter(Boolean) as number[]

    if (!selectedInformation.length) return
    InfomationService.markReadInformation(selectedInformation)
  }

  async onTranslate(index: number) {
    const item = this.news[index]

    // if already translation then back to default but still keep the cached translation
    if (item.isTranslated) {
      item.isTranslated = false
      return
    }

    // if already have text translation then use it
    if (item.content_translation) {
      item.isTranslated = true
      return
    }

    const q = [item.content]

    if (!q.length || !containsJapanese(item.content || '')) return

    await handleTranslation({
      modalId: 'news-translation-error-modal',
      q: q as string[],
      onSuccess: async (res: any) => {
        const translated = decodeHtml(res?.[0]?.translatedText) || ''
        item.isTranslated = true
        item.content_translation = translated

        return {
          target_id: item.id as number,
          type: TRANSLATION_TYPE.SYSTEM_NEWS,
          content_translation: translated
        }
      },
      onError: (message: string) => {
        this.errorMess = message
      },
    })
  }

  getMsg24Text(information: News): string {
    const updatedTerm = information.updated_term_version
    const updatedPolicy = information.updated_policy_version

    let text = ''
    if (updatedTerm) text += this.$t('acceptance.terms_of_use')
    if (updatedTerm && updatedPolicy) text += this.$t('acceptance.news_dot')
    if (updatedPolicy) text += this.$t('acceptance.privacy_policy')
    if (updatedTerm || updatedPolicy) text += this.$t('acceptance.news_text_updated')
    if (text && this.$i18n.locale !== 'ja') text += ' '
    text += this.$t('acceptance.notice')
    return text
  }

  getSystemNewsText(information: News): string {
    if (information.title === 'msg_24') {
      return this.getMsg24Text(information)
    }

    const content = information.content ? JSON.parse(information.content) : {}
    return this.$t(`information_msg.${information.title}`, {
      group_name: content.group_name || content.name_tennat,
      permission_name: content.permission_name
        ? (this.$t('permission.' + content.permission_name) as string)
        : '',
      user_name: content.user_name,
      file_name: content.file_name,
      calendar_title: content.calendar_title,
      name_tenant: content.name_tennat,
      topic_name: this.handleTopicName(information),
      count: information.unread_count
    }) as string
  }

  handleTopicName(information: News) {
    const content = information.content
    if (content) {
      if (JSON.parse(content).topic_name) {
        return `${this.$t('information_msg.msg_23_prefix')}${JSON.parse(content).topic_name}`
      }
      return ''
    }

    return ''
  }
}

interface News {
  id?: number
  title: string
  updated_term_version?: boolean
  updated_policy_version?: boolean
  unread_count?: number
  content?: string
  public_date?: string
  type?: NewsType
  target_id?: number
  target_type?: NewsTargetType
  target_parent_id?: number
  target_entity_id?: number
  is_readed: boolean
  display_place: DisplayPlace
  display_type: DisplayType
  content_translation: string
  isTranslated: boolean
}

enum NewsType {
  CMS = 1,
  SYSTEM = 2
}

enum DisplayPlace {
  HOME = 1,
  GROUP = 2,
  BOTH = 3
}

enum DisplayType {
  ONE_TIME = 1,
  CONTINUES = 2
}

enum NewsTargetType {
  NO_LINK = 1,
  GROUP_TOP = 2,
  GROUP_APPROVE = 3,
  GROUP_SETTING = 4,
  GROUP_SHARED_FOLDER = 5,
  MY_CALENDAR = 6,
  GROUP_TOPIC = 7,
  CHAT = 8,
  ACCEPTANCE = 9
}
